export const LAB_TEXT_FILE_ERROR = 'Ten plik został pominięty, ponieważ ma format binarny. W tym miejscu użyj pliku CSV, TXT lub MD. Arkusz XLS/XLSX najpierw wyeksportuj do CSV.';

const BINARY_FILE_EXTENSION = /\.(?:xls|xlsx|xlsm|ods|pdf|doc|docx|zip)$/iu;
const BINARY_SIGNATURES = [
  'PK\u0003\u0004',
  'PK\u0005\u0006',
  'PK\u0007\u0008',
];

export function getLabTextFileError(fileName: string, content: string): string | null {
  if (BINARY_FILE_EXTENSION.test(fileName.trim())) return LAB_TEXT_FILE_ERROR;
  if (content.includes('\u0000')) return LAB_TEXT_FILE_ERROR;
  if (BINARY_SIGNATURES.some(signature => content.startsWith(signature))) return LAB_TEXT_FILE_ERROR;
  return null;
}
